import { Link,useNavigate } from "react-router-dom";
import "./nav_home.css"
//import "../../pages/app-wide.css";

const NavbarHome = ({hideNav=false, isSignup=false, isLogin=false}) => {


  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const navigate = useNavigate();
  

  return (
    <nav className="nav-section-home">
      {/*logo*/}
        <div className="nav-section-home-logo-container">
            <p className="nav-section-home-title-left">Stock</p>
            <div className="nav-section-home-title-logo">
            <svg width="35" height="35">
                <circle cx="10" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="20" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="20" cy="20" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="30" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="30" cy="20" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="30" cy="10" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
            </svg>

            </div>
            <p className="nav-section-home-title-right">Archives</p>
        </div>

        <div className="nav-section-home-links-container">
          {hideNav?null:<button onClick={() => scrollTo("about")} className="nav-section-home-links-container-button">About</button>}
          {hideNav?null:<button onClick={() => scrollTo("products")} className="nav-section-home-links-container-button">Products</button>}
          {hideNav?null:<button onClick={() => scrollTo("cost")} className="nav-section-home-links-container-button">Cost</button>}
          {hideNav?null:<button onClick={() => scrollTo("faq")} className="nav-section-home-links-container-button">FAQ</button>}
        </div>

        <div className="nav-section-login-container">
            <div className="nav-section-home-login-outer">
                <Link to="/login" className={null}><button className={"nav-section-home-login-inner"}>Login</button></Link>
            </div>
        </div>
    </nav>
  );
};

export default NavbarHome;